export default __webpack_public_path__ + "d1f4fbb1b72bfc4833fa664d31287a56.png";